import { render, staticRenderFns } from "./BaseSocialLink.vue?vue&type=template&id=3ed1def4&scoped=true&"
import script from "./BaseSocialLink.vue?vue&type=script&lang=js&"
export * from "./BaseSocialLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseSocialLink.vue?vue&type=style&index=0&id=3ed1def4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1def4",
  null
  
)

export default component.exports